import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {setUpdatedPubAC} from 'store/pubs/pubSlice';
import PageEditor from 'typescript/models/PageEditor';
import {PubBeer} from 'typescript/models/PubBeer';
import PubPage from 'typescript/models/PubPage';

interface IState {
  singlePub: PubPage | null;
  pubEditors: {list: PageEditor[]; filters: {page: number; perPage: number; column: string; direction: 'asc' | 'desc'}};
  beersOnTap: {
    list: PubBeer[];
    filters: {page: number; perPage: number; column: string; direction: 'asc' | 'desc'};
    totalPages: number;
    totalCount: number;
  };
}

const initialState: IState = {
  singlePub: null,
  pubEditors: {list: [], filters: {page: 1, perPage: 5, column: 'nickname', direction: 'asc'}},
  beersOnTap: {
    list: [],
    filters: {page: 1, perPage: 5, column: 'beer.name', direction: 'asc'},
    totalPages: 1,
    totalCount: 0,
  },
};

export const pubPageNamespace = '[pub-page]';

const pubPageSlice = createSlice({
  name: pubPageNamespace,
  initialState,
  reducers: {
    setSinglePubAC: (state, action: PayloadAction<IState['singlePub']>) => {
      state.singlePub = action.payload;
    },
    setPubEditorsAC: (state, action: PayloadAction<PageEditor[]>) => {
      state.pubEditors.list = action.payload;
    },
    addPubEditorAC: (state, action: PayloadAction<PageEditor>) => {
      state.pubEditors.list.push(action.payload);
    },
    removeUnassignedPubEditorAC: (state, action: PayloadAction<string>) => {
      state.pubEditors.list = state.pubEditors.list.filter((editor) => editor.id !== action.payload);
    },
    setBeersOnTapFiltersAC: (state, action: PayloadAction<IState['beersOnTap']['filters']>) => {
      state.beersOnTap = {...state.beersOnTap, filters: action.payload};
    },
    setPageEditorFiltersAC: (state, action: PayloadAction<IState['pubEditors']['filters']>) => {
      state.pubEditors = {...state.pubEditors, filters: action.payload};
    },
    setBeersOnTapAC: (state, action: PayloadAction<{totalPages: number; list: PubBeer[]; totalCount: number}>) => {
      state.beersOnTap = {
        ...state.beersOnTap,
        totalPages: action.payload.totalPages,
        list: action.payload.list,
        totalCount: action.payload.totalCount,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setUpdatedPubAC, (state, action) => {
      state.singlePub = action.payload;
    });
  },
});

export default pubPageSlice;

export const {
  setBeersOnTapFiltersAC,
  setBeersOnTapAC,
  setSinglePubAC,
  setPubEditorsAC,
  removeUnassignedPubEditorAC,
  addPubEditorAC,
  setPageEditorFiltersAC,
} = pubPageSlice.actions;
